import { React, useContext, useEffect, useRef, useState } from "react";
import { PageContext } from "../../App";
import {
  formatBytes,
  getExtensionFromMimeType,
  getFileExtension,
} from "../Utils";
import { saveFile } from "../Utils";
import ImageViewerView from "../image_viewer/ImageViewerView";
import ImageDrawMode from "../image_converter/ImageDrawMode";
import OutputLayout from "./OutputLayout";
import { HexColorPicker } from "react-colorful";
import OutputDimentionScale from "./OutputDimentionScale";
import { mergeImages } from "../ImageHelper/ImageRenderer";

function MergeImagesListImageScreen(props) {
  // AppStatus.ts
  const AppState = {
    LOADED: "LOADED",
    PROCESSING: "PROCESSING",
    PROCESSED: "PROCESSED",
    NONE: "NONE",
  };

  //initialized flaf
  const initializedRef = useRef(false);
  //fileinfo list
  //store thumbnail, page count etc key is filepath
  const [filesInfo, setFilesInfo] = useState({});
  //output settings
  const [outputSettings, setOutputSettings] = useState({
    type: {
      popupShowing: false,
      export_as: ".jpg",
      mimetype: "image/jpeg",
    },
    drawMode: {
      draw_mode: ImageDrawMode.ASPECT_FILL,
      popupShowing: false,
    }, //image draw mode
    layout: {
      layout: OutputLayout.HORIZONTAL,
      popupShowing: false,
    }, //image draw mode
    bgcolor: { bgcolor: "#000000", popupShowing: false },
    padding: 0, //in pixels
    margin: 5, //in pixels
    outputDimension: {
      outputDimension: OutputDimentionScale.AUTO,
      width: 1920,
      height: 1080,
      popupShowing: false,
    },
  });
  //is merging
  const [isMerging, setIsMerging] = useState(false);

  //show image preview
  const [showImagePreview, setShowImagePreview] = useState({
    preview: false,
    file: null,
  });

  //get context
  const {
    selectedFiles,
    setSelectedFiles,
    setShowEditFileScreen,
    setStartProcessingFiles,
  } = useContext(PageContext);

  //start
  useEffect(() => {
    //check
    if (initializedRef.current === false) {
      //set
      initializedRef.current = true;
      //generate thumbnails
      generateThumbnails();

      console.log("Load top loading bar");
    }

    //if selected files list is empty
    //reset screen
    //show upload button
    if (selectedFiles.length === 0) {
      //reset
      resetScreen();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedFiles]);

  //generate thumbnails
  const generateThumbnails = () => {
    //loop
    //read files
    //get thumbnails
    for (let i = 0; i < selectedFiles.length; i++) {
      //selected file
      const selectedFile = selectedFiles[i];
      //path image file
      const key = String(selectedFile.path);
      //set image
      setFilesInfo((prevDictionary) => ({
        ...prevDictionary,
        [key]: {
          ...filesInfo[key],
          state: AppState.LOADED,
          thumbnail: URL.createObjectURL(selectedFile),
          message: "",
          mimeType: selectedFile.type,
          name: selectedFile.name,
          file: selectedFile, //selected file
          size: selectedFile.size, //in bytes
        },
      }));
    }
  };

  //reset screen
  //remove files info
  //empty selected files list
  const resetScreen = () => {
    //set flags
    setSelectedFiles([]);
    setShowEditFileScreen(false);
    setFilesInfo({});
    setStartProcessingFiles(false);
  };

  //render files list view
  const renderFilesListView = () =>
    //render
    selectedFiles.map((item, index) => (
      <div
        className="mt-3"
        key={index}
        style={{ cursor: "pointer" }}
        onClick={(e) => {
          //show preview
          setShowImagePreview({
            ...showImagePreview,
            preview: true,
            file: item,
          });
        }}
      >
        {/* Flex container left image right name and size */}
        <div className="position-relative d-flex bg-light border rounded-1 px-sm-3 px-2 py-4">
          {/* Arrow */}
          <div
            className="justify-content-center align-items-center text-center btn-group-vertical my-auto"
            data-toggle="buttons"
          >
            {/* Up Arrow */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();
                //destination index
                let targetIndex = Math.max(0, index - 1);
                //filter array
                //remove element from array
                let filteredArray = selectedFiles.filter((a) => a !== item);
                //Create the first part of the array (before the index)
                const firstPart = filteredArray.slice(0, targetIndex);
                //Create the second part of the array (from the index onwards)
                const secondPart = filteredArray.slice(targetIndex);
                //Combine them into a new array with the new item inserted
                const updatedItems = [...firstPart, item, ...secondPart];
                //set
                setSelectedFiles(updatedItems);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-caret-up-fill"
                viewBox="0 0 16 16"
              >
                <path d="m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" />
              </svg>
            </button>
            {/* Down Arrow */}
            <button
              className="btn btn-outline-secondary btn-sm border-0"
              type="button"
              onClick={(e) => {
                // Stops the click from bubbling up to the 'div' above
                e.stopPropagation(); // W3C standard
                //blur
                e.currentTarget.blur();
                //destination index
                let targetIndex = Math.min(selectedFiles.length - 1, index + 1);
                //filter array
                //remove element from array
                let filteredArray = selectedFiles.filter((a) => a !== item);
                //Create the first part of the array (before the index)
                const firstPart = filteredArray.slice(0, targetIndex);
                //Create the second part of the array (from the index onwards)
                const secondPart = filteredArray.slice(targetIndex);
                //Combine them into a new array with the new item inserted
                const updatedItems = [...firstPart, item, ...secondPart];
                //set
                setSelectedFiles(updatedItems);
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-caret-down-fill"
                viewBox="0 0 16 16"
              >
                <path d="M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" />
              </svg>
            </button>
          </div>
          {/* Left image */}
          <div className="ms-sm-3 ms-1 my-auto">
            <div
              className="d-flex justify-content-center align-items-center"
              style={{ width: "80px", height: "80px" }}
            >
              {/* Image */}
              <img
                loading="lazy"
                src={
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].thumbnail != null
                      ? filesInfo[String(item.path)].thumbnail
                      : "./images/file_icon.png"
                    : "./images/file_icon.png"
                }
                alt="image_icon"
                style={{
                  width: "auto",
                  height: "auto",
                  maxWidth: "80px",
                  maxHeight: "80px",
                }}
              ></img>
            </div>
          </div>

          {/* Right name and size */}
          <div className="ms-3 my-auto d-none d-md-block d-sm-block me-5">
            <div className="px-2 fs-5 text-dark-subtle">{item.name}</div>
            <div className="d-flex">
              {/* File size */}
              <div className="px-2 fs-6 text-body-secondary">
                Size: {formatBytes(item.size)}
              </div>
              {/* file type */}
              <div
                className={`px-2 ms-2 my-auto rounded-2 fw-bold ${
                  String(item.path) in filesInfo
                    ? filesInfo[String(item.path)].state === AppState.PROCESSED
                      ? "text-success"
                      : "bg-danger text-white"
                    : "bg-danger text-white"
                }`}
              >
                {String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSED
                    ? "MERGED"
                    : getFileExtension(item.name.toUpperCase())
                  : getFileExtension(item.name.toUpperCase())}
              </div>
            </div>
            {/* Page Count */}
            <div className="px-2 fs-6 text-body-secondary">
              {`Index: ${index + 1}`}
            </div>
            {/* Warning */}
            <div
              className={`px-2 text-primary mt-3 text-lead ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].message !== ""
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              style={{ fontSize: "16px" }}
            >
              {String(item.path) in filesInfo
                ? filesInfo[String(item.path)].message
                : ""}
            </div>
          </div>

          {/* Right side views spinner, download and delete buttons */}
          <div
            className="position-absolute justify-content-center align-items-center text-center my-auto"
            style={{ right: "0px", top: "50%", transform: "translateY(-50%)" }}
          >
            {/* Show spinner while processing */}
            {/* Spinner */}
            <div
              className={`spinner-border my-auto me-2 ms-sm-3 ms-2 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.PROCESSING
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
              role="status"
            >
              <span className="visually-hidden">Loading...</span>
            </div>
            {/* Delete Button */}
            {/* Show delete button after loaded */}
            <div
              className={`my-auto me-2 ms-1 ${
                String(item.path) in filesInfo
                  ? filesInfo[String(item.path)].state === AppState.LOADED ||
                    filesInfo[String(item.path)].state === AppState.NONE
                    ? ""
                    : "d-none"
                  : "d-none"
              }`}
            >
              <button
                type="button"
                className="btn btn-outline-danger"
                onClick={(e) => {
                  //stop propagating
                  e.stopPropagation();
                  //remove file from selectedfiles list
                  setSelectedFiles(selectedFiles.filter((a) => a !== item));
                  //remove thumbnails
                  setFilesInfo((currentData) => {
                    // Destructure the key to remove into a throwaway variable (e.g., '_')
                    // and collect the rest of the properties into a new object 'rest'
                    const { [String(item.path)]: _, ...rest } = currentData;
                    //return
                    return rest;
                  });
                }}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="currentColor"
                  className="bi bi-trash"
                  viewBox="0 0 16 16"
                >
                  <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5m3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0z" />
                  <path d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4zM2.5 3h11V2h-11z" />
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    //show hide loading view
    <div className="position-relative">
      {/* show image preview */}
      {/* page main content */}
      {showImagePreview.preview ? (
        <ImageViewerView
          title={
            showImagePreview.file === null ? "" : showImagePreview.file.name
          }
          onClose={() => {
            //set preview
            setShowImagePreview({
              ...showImagePreview,
              preview: false,
              file: null,
            });
          }}
          file={showImagePreview.file}
        ></ImageViewerView>
      ) : (
        <div>
          {/* Top bar */}
          <div className="bg-light border-bottom my-auto sticky-top">
            <div className="d-flex">
              <button
                type="button"
                className="btn btn-transparent"
                onClick={resetScreen}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="26"
                  height="26"
                  fill="#000000"
                  className="bi bi-arrow-clockwise"
                  viewBox="0 0 16 16"
                >
                  <path
                    fillRule="evenodd"
                    d="M8 3a5 5 0 1 0 4.546 2.914.5.5 0 0 1 .908-.417A6 6 0 1 1 8 2z"
                  />
                  <path d="M8 4.466V.534a.25.25 0 0 1 .41-.192l2.36 1.966c.12.1.12.284 0 .384L8.41 4.658A.25.25 0 0 1 8 4.466" />
                </svg>
              </button>
              {/* Title */}
              <label className="fs-3 ms-2 py-2 text-secondary fs-4">
                {props.title ?? "Merge Images"}
              </label>
            </div>
          </div>

          {/*Container left list & right controls */}
          <div
            className="d-flex"
            style={{
              height: "calc(100vh - 52px)",
              maxHeight: "calc(100vh - 52px)",
            }}
          >
            {/* Left List */}
            <div
              className="mt-md-5 mt-sm-3 mt-1 ms-sm-5 ms-1 mb-3"
              style={{ width: "75%", maxWidth: "75%", overflowY: "auto" }}
            >
              {renderFilesListView()}
            </div>

            {/* Right controls */}
            <div
              className="ms-sm-5 ms-1  border-start position-relative"
              style={{
                marginBottom: "100px", //add space to bottom for button, else overlap
                width: "25%",
                maxWidth: "25%",
                overflowY: "auto",
                minWidth: "200px",
              }}
            >
              {/* Additional settings */}
              <div
                className="ms-4 "
                style={{
                  width: "calc(100% - 48px)",
                }}
              >
                {/* Additional settings */}
                <div className="w-100 mt-4 border-bottom pb-3">
                  <label className="fs-4">Configurations:</label>
                </div>

                {/* layout */}
                <div className="d-flex mt-4 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Layout:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenuLayout"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setOutputSettings({
                          ...outputSettings,
                          layout: {
                            ...outputSettings.layout,
                            popupShowing:
                              outputSettings.layout.popupShowing === true
                                ? false
                                : true,
                          },
                          type: {
                            ...outputSettings.type,
                            popupShowing: false,
                          },
                          drawMode: {
                            ...outputSettings.drawMode,
                            popupShowing: false,
                          },
                          bgcolor: {
                            ...outputSettings.bgcolor,
                            popupShowing: false,
                          },
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {outputSettings.layout.layout}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        outputSettings.layout.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenuLayout"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                              layout: OutputLayout.HORIZONTAL,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {OutputLayout.HORIZONTAL}
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                              layout: OutputLayout.VERTICAL,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {OutputLayout.VERTICAL}
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                              layout: OutputLayout.GRID,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {OutputLayout.GRID}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Draw mode */}
                <div className="d-flex mt-2 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Draw Mode:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenuDrawMode"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setOutputSettings({
                          ...outputSettings,
                          drawMode: {
                            ...outputSettings.drawMode,
                            popupShowing:
                              outputSettings.drawMode.popupShowing === true
                                ? false
                                : true,
                          },
                          type: {
                            ...outputSettings.type,
                            popupShowing: false,
                          },
                          layout: {
                            ...outputSettings.layout,
                            popupShowing: false,
                          },
                          bgcolor: {
                            ...outputSettings.bgcolor,
                            popupShowing: false,
                          },
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {outputSettings.drawMode.draw_mode}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        outputSettings.drawMode.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenuDrawMode"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                              draw_mode: ImageDrawMode.SCAlE_TO_FILL,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {ImageDrawMode.SCAlE_TO_FILL}
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                              draw_mode: ImageDrawMode.ASPECT_FILL,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {ImageDrawMode.ASPECT_FILL}
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                              draw_mode: ImageDrawMode.ASPECT_FIT,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {ImageDrawMode.ASPECT_FIT}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Output image file type */}
                <div className="d-flex mt-2 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Export as:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenuImageType"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setOutputSettings({
                          ...outputSettings,
                          type: {
                            ...outputSettings.type,
                            popupShowing:
                              outputSettings.type.popupShowing === true
                                ? false
                                : true,
                          },
                          drawMode: {
                            ...outputSettings.drawMode,
                            popupShowing: false,
                          },
                          layout: {
                            ...outputSettings.layout,
                            popupShowing: false,
                          },
                          bgcolor: {
                            ...outputSettings.bgcolor,
                            popupShowing: false,
                          },
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {outputSettings.type.export_as}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        outputSettings.type.popupShowing === true ? "show" : ""
                      }`}
                      aria-labelledby="dropdownMenuImageType"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".jpg",
                              mimetype: "image/jpg",
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .jpg
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".jpeg",
                              mimetype: "image/jpeg",
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .jpeg
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".png",
                              mimetype: "image/png",
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .png
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".bmp",
                              mimetype: "image/bmp",
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .bmp
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".webp",
                              mimetype: "image/webp",
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .webp
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                              export_as: ".svg",
                              mimetype: "image/svg+xml",
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        .svg
                      </button>
                    </div>
                  </div>
                </div>

                {/* Background Color */}
                <div className="d-flex mt-2 my-auto">
                  <div>
                    {/* Label */}
                    <label className="fs-6 me-2 text-secondary py-2">
                      Background Color:
                    </label>
                    {/* Show color value */}
                    <label
                      className={`text-center py-1 px-3 rounded-2 ${
                        outputSettings.bgcolor.bgcolor !== "#ffffff"
                          ? "text-white"
                          : "text-dark"
                      }`}
                      style={{
                        backgroundColor: outputSettings.bgcolor.bgcolor,
                      }}
                      onClick={(e) => {
                        //show hide color picker
                        //turn other popups off
                        setOutputSettings({
                          ...outputSettings,
                          bgcolor: {
                            ...outputSettings.bgcolor,
                            popupShowing:
                              outputSettings.bgcolor.popupShowing === true
                                ? false
                                : true,
                          },
                          layout: {
                            ...outputSettings.layout,
                            popupShowing: false,
                          },
                          drawMode: {
                            ...outputSettings.drawMode,
                            popupShowing: false,
                          },
                          type: { ...outputSettings.type, popupShowing: false },
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {outputSettings.bgcolor.bgcolor}
                    </label>
                    {/* Color Picker */}
                    <HexColorPicker
                      className={`my-custom-picker mt-2 ${
                        outputSettings.bgcolor.popupShowing === true
                          ? ""
                          : "d-none"
                      }`}
                      color={outputSettings.bgcolor.bgcolor}
                      onChange={(color) => {
                        //set
                        setOutputSettings({
                          ...outputSettings,
                          bgcolor: {
                            ...outputSettings.bgcolor,
                            bgcolor: color,
                          },
                        });
                      }}
                    />
                  </div>
                </div>

                {/* Padding */}
                <div
                  className="d-flex mt-2 my-auto text-center"
                  style={{ height: "48px", maxHeight: "48px" }}
                >
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary py-3">
                    Padding (in px):
                  </label>
                  {/*Input */}
                  <input
                    type="number"
                    className="form-control mt-2 ms-2"
                    id="padding"
                    placeholder="5 px"
                    onChange={(e) => {
                      //set padding
                      setOutputSettings({
                        ...outputSettings,
                        padding: e.target.value,
                      });
                    }}
                    value={outputSettings.padding}
                    style={{ width: "100px" }}
                  />
                </div>

                {/* margin */}
                <div
                  className="d-flex mt-2 my-auto text-center"
                  style={{ height: "48px", maxHeight: "48px" }}
                >
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary py-3">
                    Margin (in px):
                  </label>
                  {/*Input */}
                  <input
                    type="number"
                    className="form-control mt-2 ms-2"
                    id="margin"
                    placeholder="5 px"
                    onChange={(e) => {
                      //set padding
                      setOutputSettings({
                        ...outputSettings,
                        margin: e.target.value,
                      });
                    }}
                    value={outputSettings.margin}
                    style={{ width: "100px" }}
                  />
                </div>

                {/* Output Size label  */}
                <div className="w-100 mt-5 border-bottom pb-3">
                  <label className="fs-4">Output Size:</label>
                </div>

                {/* Output Dimension */}
                <div className="d-flex mt-4 my-auto text-center">
                  {/* Label */}
                  <label className="fs-6 me-2 text-secondary">Size:</label>
                  {/* Dropdown menu */}
                  <div className="dropdown">
                    <label
                      className="dropdown-toggle fs-6 text-primary"
                      type="text"
                      id="dropdownMenuOutputDimensionScale"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                      style={{ cursor: "pointer" }}
                      onClick={(e) => {
                        //toggle
                        setOutputSettings({
                          ...outputSettings,
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            popupShowing:
                              outputSettings.outputDimension.popupShowing ===
                              true
                                ? false
                                : true,
                          },
                          type: {
                            ...outputSettings.type,
                            popupShowing: false,
                          },
                          layout: {
                            ...outputSettings.layout,
                            popupShowing: false,
                          },
                          bgcolor: {
                            ...outputSettings.bgcolor,
                            popupShowing: false,
                          },
                          drawMode: {
                            ...outputSettings.drawMode,
                            popupShowing: false,
                          },
                        });
                      }}
                    >
                      {outputSettings.outputDimension.outputDimension}
                    </label>
                    <div
                      className={`dropdown-menu ${
                        outputSettings.outputDimension.popupShowing === true
                          ? "show"
                          : ""
                      }`}
                      aria-labelledby="dropdownMenuOutputDimensionScale"
                    >
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                              outputDimension: OutputDimentionScale.AUTO,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {OutputDimentionScale.AUTO}
                      </button>
                      <button
                        className="dropdown-item"
                        type="button"
                        onClick={(e) => {
                          //set configuration
                          setOutputSettings({
                            ...outputSettings,
                            outputDimension: {
                              ...outputSettings.outputDimension,
                              popupShowing: false,
                              outputDimension: OutputDimentionScale.FIXED_SIZE,
                            },
                            type: {
                              ...outputSettings.type,
                              popupShowing: false,
                            },
                            layout: {
                              ...outputSettings.layout,
                              popupShowing: false,
                            },
                            bgcolor: {
                              ...outputSettings.bgcolor,
                              popupShowing: false,
                            },
                            drawMode: {
                              ...outputSettings.drawMode,
                              popupShowing: false,
                            },
                          });
                        }}
                      >
                        {OutputDimentionScale.FIXED_SIZE}
                      </button>
                    </div>
                  </div>
                </div>

                {/* Output Size */}
                <div
                  className={`bg-light ms-2 mt-2 rounded-2 p-1 ${outputSettings.outputDimension.outputDimension === OutputDimentionScale.FIXED_SIZE ? "" : "d-none"}`}
                >
                  {/* Width */}
                  <div
                    className="d-flex my-auto text-center"
                    style={{ height: "48px", maxHeight: "48px" }}
                  >
                    {/* Label */}
                    <label
                      className="fs-6 me-2 text-secondary py-3"
                      style={{ minWidth: "55px" }}
                    >
                      W (px):
                    </label>
                    {/*Input */}
                    <input
                      type="number"
                      className="form-control mt-2 ms-2"
                      id="output_width"
                      placeholder="0 px"
                      value={outputSettings.outputDimension.width}
                      onChange={(e) => {
                        //set padding
                        setOutputSettings({
                          ...outputSettings,
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            width: e.target.value,
                          },
                        });
                      }}
                      style={{ width: "80px" }}
                    />
                  </div>

                  {/* Height */}
                  <div
                    className="d-flex mt-2 my-auto text-center"
                    style={{ height: "48px", maxHeight: "48px" }}
                  >
                    {/* Label */}
                    <label
                      className="fs-6 me-2 text-secondary py-3"
                      style={{ minWidth: "55px" }}
                    >
                      H (px):
                    </label>
                    {/*Input */}
                    <input
                      type="number"
                      className="form-control mt-2 ms-2"
                      id="output_height"
                      placeholder="0 px"
                      value={outputSettings.outputDimension.height}
                      onChange={(e) => {
                        //set padding
                        setOutputSettings({
                          ...outputSettings,
                          outputDimension: {
                            ...outputSettings.outputDimension,
                            height: e.target.value,
                          },
                        });
                      }}
                      style={{ width: "80px" }}
                    />
                  </div>
                </div>
              </div>

              {/* Convert Button */}
              <button
                className={`btn btn-danger py-2 py-sm-3 fs-4 position-fixed rounded-3 ${
                  isMerging ? "disabled" : ""
                }`}
                style={{
                  marginLeft: "10px",
                  width:
                    window !== undefined
                      ? window.innerWidth * 0.25 < 200
                        ? "180px"
                        : window.innerWidth * 0.25 - 40
                      : "180px",
                  bottom: "10px",
                }}
                type="button"
                onClick={async (e) => {
                  //hide all popups
                  setOutputSettings({
                    ...outputSettings,
                    type: { ...outputSettings.type, popupShowing: false },
                    bgcolor: { ...outputSettings.bgcolor, popupShowing: false },
                    layout: { ...outputSettings.layout, popupShowing: false },
                    drawMode: {
                      ...outputSettings.drawMode,
                      popupShowing: false,
                    },
                    outputDimension: {
                      ...outputSettings.outputDimension,
                      popupShowing: false,
                    },
                  });
                  //set
                  setIsMerging(true);
                  //loop
                  for (var i = 0; i < selectedFiles.length; i++) {
                    //selected file
                    const selectedFile = selectedFiles[i];
                    //key
                    const key = String(selectedFile.path);
                    //check
                    if (key in filesInfo) {
                      //set
                      //set blob
                      setFilesInfo((prevDictionary) => ({
                        ...prevDictionary,
                        [key]: {
                          ...filesInfo[key],
                          state: AppState.PROCESSING,
                          message: `Processing image...`,
                        },
                      }));
                    }
                  }

                  //merge images
                  await mergeImages(
                    selectedFiles,
                    {
                      type: outputSettings.type.mimetype,
                      layout: outputSettings.layout.layout,
                      drawMode: outputSettings.drawMode.draw_mode,
                      bgcolor: outputSettings.bgcolor.bgcolor,
                      padding: Number(outputSettings.padding),
                      margin: Number(outputSettings.margin),
                      outputDimensionType:
                        outputSettings.outputDimension.outputDimension,
                      outputDimension: {
                        width: Number(outputSettings.outputDimension.width),
                        height: Number(outputSettings.outputDimension.height),
                      },
                    },
                    (blob) => {
                      //loop
                      for (var i = 0; i < selectedFiles.length; i++) {
                        //selected file
                        const selectedFile = selectedFiles[i];
                        //key
                        const key = String(selectedFile.path);
                        //check
                        if (key in filesInfo) {
                          //set
                          //set blob
                          setFilesInfo((prevDictionary) => ({
                            ...prevDictionary,
                            [key]: {
                              ...filesInfo[key],
                              state: AppState.PROCESSED,
                              message: `Successfully merged images. Merged image will be downloaded automatically on your device.`,
                            },
                          }));
                        }
                      }

                      //save file
                      saveFile(
                        blob,
                        `merged_image.${getExtensionFromMimeType(outputSettings.type.mimetype)}`,
                      );
                    },
                  );
                  //reset
                  setIsMerging(false);
                }}
              >
                MERGE
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default MergeImagesListImageScreen;
